import { useRef, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../../utils/auth";
import "../../../assets/bp/style.css";
import "../../../assets/bp/site.min.css";
import "../../../assets/bp/BPEXCH-style.css";
import { refreshSessionData } from "../../../utils/refreshSessionData";
import { onChartBalanceRefresh } from "../../../utils/chartBalanceRefresh";
import { isMobile } from "react-device-detect";
import Marquee from "react-fast-marquee";

function toEventList(value) {
  if (Array.isArray(value)) return value;
  if (value && typeof value === "object") return Object.values(value);
  return [];
}

const AgentLayout = ({ children, showLoader = true }) => {
  const [displaySidebar, setDisplaySidebar] = useState(isMobile ? false : true);
  const [openSubMenu, setOpenSubMenu] = useState("");
  const [displayTopRightMenu, setDisplayTopRightMenu] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const response = useSelector((state) => state.userStore);
  const username = response.data?.uname ?? "....";
  const userRole = response.data?.user_role ?? "";
  const userBalance = Math.round(response.data?.bz_balance ?? 0);
  const userExposure = Math.round(response.data?.header_exposure ?? 0);

  const handleSubMenuClick = (menu, event) => {
    event.preventDefault();
    event.stopPropagation();
    setOpenSubMenu((current) => (current === menu ? "" : menu));
  };

  useEffect(() => {
    return onChartBalanceRefresh(() => {
      refreshSessionData(dispatch).catch(console.error);
    });
  }, [dispatch]);

  const eventsFromParent = useSelector((state) => state.event);

  let cricketList = [];
  let tennisList = [];
  let footballList = [];
  let horseList = [];
  let greyList = [];

  if (eventsFromParent.data != null && eventsFromParent.data != undefined) {
    cricketList = toEventList(eventsFromParent.data.result).filter(
      (event) => event.sports_type === 1
    );
    footballList = toEventList(eventsFromParent.data.result).filter(
      (event) => event.sports_type === 2
    );
    tennisList = toEventList(eventsFromParent.data.result).filter(
      (event) => event.sports_type === 3
    );
    horseList = toEventList(eventsFromParent.data.horse).filter(
      (event) => event.sports_type === 4
    );
    greyList = toEventList(eventsFromParent.data.grey).filter(
      (event) => event.sports_type === 5
    );
  }

  const topRightMenuRef = useRef(null);
  // Function to handle clicks outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        topRightMenuRef.current &&
        !topRightMenuRef.current.contains(event.target)
      ) {
        setDisplayTopRightMenu(false); // Or update any value/state you want
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const formatTruncate = (value) => {
    let num = Math.round(value);
    const truncated = Math.floor(num * 1000) / 1000;

    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 3
    }).format(truncated);
  };

  const setRole = (roleId) => {
    let roleTxt = "";
    if (roleId == 1) {
      roleTxt = "Owner Company";
    } else if (roleId == 2) {
      roleTxt = "Super Company";
    } else if (roleId == 3) {
      roleTxt = "Company";
    } else if (roleId == 4) {
      roleTxt = "SuperAdmin";
    } else if (roleId == 5) {
      roleTxt = "Admin";
    } else if (roleId == 6) {
      roleTxt = "Super Master";
    } else if (roleId == 7) {
      roleTxt = "Master";
    }

    return roleTxt;
  };

  return (
    <>
      <div
        className={
          displaySidebar
            ? "app header-fixed sidebar-fixed aside-menu-fixed sidebar-lg-show"
            : "app header-fixed sidebar-fixed aside-menu-fixed sidebar-lg-hide"
        }
      >
        <header className="app-header navbar">
          <button
            onClick={() => setDisplaySidebar(!displaySidebar)}
            className="navbar-toggler sidebar-toggler d-lg-none mr-auto"
            type="button"
            data-toggle="sidebar-show"
          >
            <span className="navbar-toggler-icon" />
          </button>
          <div className="logo-bar">
            <a href="/agent/">
              <span
                className="green-logo-text d-sm-down-none site_family"
                style={{ color: "#02b180", paddingLeft: "17px" }}
              >
                BPEXCH
              </span>
            </a>
          </div>
          <button
            className="navbar-toggler sidebar-toggler d-md-down-none"
            type="button"
            data-toggle="sidebar-lg-show"
            onClick={() => setDisplaySidebar(!displaySidebar)}
          >
            <span className="navbar-toggler-icon" />
          </button>
          <ul className="nav navbar-nav d-md-down-none">
            <li className="nav-item px-3">
              <Link
                className="nav-link site_family active"
                to="/agent/dashboard"
              >
                Dashboard
              </Link>
            </li>
            <li className="nav-item px-3">
              <Link to="/agent/accounts/chart" className="nav-link site_family">
                Users
              </Link>
            </li>
            <li className="nav-item px-3">
              <Link className="nav-link site_family" to="/agent/book-detail">
                Reports
              </Link>
            </li>
          </ul>

          <ul className="nav navbar-nav ml-auto topUname" ref={topRightMenuRef}>
            <li className="nav-item px-2">
              <a
                className="nav-link site_family"
                data-toggle="dropdown"
                href="#"
                role="button"
                aria-haspopup="true"
                aria-expanded="false"
                onClick={() => setDisplayTopRightMenu(!displayTopRightMenu)}
              >
                {username} ({setRole(userRole)}){" "}
                <i className="fa fa-caret-down" />
              </a>
              <div
                className={`dropdown-menu dropdown-menu-right ${
                  displayTopRightMenu ? " show" : ""
                }`}
              >
                <Link
                  className="dropdown-item site_family"
                  to="/agent/reset-password"
                >
                  <i className="fa fa-user" /> Profile
                </Link>
                <Link
                  className="dropdown-item site_family"
                  id="btn-logout"
                  href="#"
                  onClick={() => logout(dispatch, navigate)}
                >
                  <i className="fa fa-sign-out" /> Logout
                </Link>
              </div>
            </li>
            <li className="nav-item">
              <a
                className="nav-link site_family"
                href="/agent/market-analyses-list"
                role="button"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <strong>B:</strong>
                <span className="wallet-balance">
                  {formatTruncate(Math.round(userBalance))}{" "}
                </span>
                <strong>Exp:</strong>{" "}
                <span className="wallet-exposure">
                  {" "}
                  <span id="expTop">
                    {formatTruncate(Math.round(userExposure))}
                  </span>
                </span>
              </a>
            </li>
          </ul>
        </header>

        <div className="app-body" style={{ background: "#e4e5e6" }}>
          <div className="sidebar-agent">
            <nav className="sidebar-nav ps">
              <ul className="nav">
                <li className="nav-item">
                  <Link
                    className="nav-link site_family active"
                    to="/agent/dashboard"
                  >
                    <i className="nav-icon fas fa-tachometer-alt fa-inverse " />{" "}
                    Dashboard
                  </Link>
                </li>
                <li className="nav-item open">
                  <Link
                    className="nav-link site_family"
                    to="/agent/accounts/chart"
                  >
                    <i className="nav-icon fa fa-users fa-inverse" /> Users
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="nav-link site_family"
                    to="/agent/market-analyses-list"
                  >
                    <i className="nav-icon fa fa-funnel-dollar fa-inverse" />{" "}
                    Current Position
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="nav-link site_family"
                    to="/agent/book-detail"
                  >
                    <i className="nav-icon fa fa-money-check fa-inverse" />{" "}
                    Reports
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link site_family" to="/agent/bet-lock">
                    <i className="nav-icon fa fa-unlock-alt fa-inverse" /> Bet
                    Lock
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="nav-link site_family"
                    to="javascript:void(0)"
                  >
                    <i className="nav-icon fa fa-star fa-inverse" /> Star Casino
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="nav-link site_family"
                    href="javascript:void(0)"
                  >
                    <i className="nav-icon fa fa-globe fa-inverse" /> World
                    Casino
                  </Link>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link site_family"
                    href="/agent/betfair-dashboard"
                  >
                    <i className="nav-icon fa fa-globe fa-inverse" /> BetFair
                    Games
                  </a>
                </li>
                <li
                  className={`nav-item nav-dropdown${
                    openSubMenu === "soccer" ? " open" : ""
                  }`}
                >
                  <a
                    className="nav-link nav-dropdown-toggle site_family"
                    href="#"
                    onClick={(event) => handleSubMenuClick("soccer", event)}
                  >
                    <img
                      src="../../../assets/images/menu-icon/soccer.svg?v="
                      alt="Soccer"
                    />{" "}
                    Soccer
                  </a>
                  <ul className="nav-dropdown-items " id="left_soccer_div">
                    {footballList.map((football) => (
                      <li className="nav-item site_family">
                        <a
                          className="nav-link site_family"
                          href={`/agent/market-analysis/${football.mid}`}
                        >
                          {football.name}
                        </a>
                      </li>
                    ))}
                  </ul>
                </li>

                <li
                  className={`nav-item nav-dropdown${
                    openSubMenu === "tennis" ? " open" : ""
                  }`}
                >
                  <a
                    className="nav-link nav-dropdown-toggle site_family"
                    href="#"
                    onClick={(event) => handleSubMenuClick("tennis", event)}
                  >
                    <img
                      src="../../../assets/images/menu-icon/tennis.svg"
                      alt="Tennis"
                    />{" "}
                    Tennis
                  </a>
                  <ul className="nav-dropdown-items" id="left_tennis_div">
                    {tennisList.map((tennis) => (
                      <li className="nav-item">
                        <a
                          className="nav-link site_family"
                          href={`/agent/market-analysis/${tennis.mid}`}
                        >
                          {tennis.name}
                        </a>
                      </li>
                    ))}
                  </ul>
                </li>

                <li
                  className={`nav-item nav-dropdown${
                    openSubMenu === "cricket" ? " open" : ""
                  }`}
                >
                  <a
                    className="nav-link nav-dropdown-toggle site_family"
                    href="#"
                    onClick={(event) => handleSubMenuClick("cricket", event)}
                  >
                    <img
                      src="../../../assets/images/menu-icon/cricket.svg?v="
                      alt="Cricket"
                    />{" "}
                    Cricket
                  </a>
                  <ul className="nav-dropdown-items" id="left_cricket_div">
                    {cricketList.map((cricket) => (
                      <li className="nav-item">
                        <a
                          className="nav-link site_family"
                          href={`/agent/market-analysis/${cricket.mid}`}
                        >
                          {cricket.name}
                        </a>
                      </li>
                    ))}
                  </ul>
                </li>

                <li
                  className={`nav-item nav-dropdown${
                    openSubMenu === "horse" ? " open" : ""
                  }`}
                >
                  <a
                    className="nav-link nav-dropdown-toggle site_family"
                    href="#"
                    onClick={(event) => handleSubMenuClick("horse", event)}
                  >
                    <img
                      src="../../../assets/images/menu-icon/horse.svg?v="
                      alt="Horse"
                    />{" "}
                    Horse Race
                  </a>
                  <ul className="nav-dropdown-items" id="left_horse_div">
                    {horseList.map((hourse) => (
                      <li className="nav-item site_family">
                        <a
                          className="nav-link"
                          href={`/agent/market-analysis/${hourse.mid}`}
                        >
                          {hourse.name}
                        </a>
                      </li>
                    ))}
                  </ul>
                </li>

                <li
                  className={`nav-item nav-dropdown${
                    openSubMenu === "greyhound" ? " open" : ""
                  }`}
                >
                  <a
                    className="nav-link nav-dropdown-toggle site_family"
                    href="#"
                    onClick={(event) => handleSubMenuClick("greyhound", event)}
                  >
                    <img
                      src="../../../assets/images/menu-icon/greyhound-racing.svg"
                      alt="Greyhound"
                    />{" "}
                    Greyhound
                  </a>
                  <ul className="nav-dropdown-items" id="left_greyhound_div">
                    {greyList.map((gray) => (
                      <li className="nav-item site_family">
                        <a
                          className="nav-link"
                          href={`/agent/market-analysis/${gray.mid}`}
                        >
                          {gray.name}
                        </a>
                      </li>
                    ))}
                  </ul>
                </li>
              </ul>
              <div className="ps__rail-x" style={{ left: 0, bottom: 0 }}>
                <div
                  className="ps__thumb-x"
                  tabIndex={0}
                  style={{ left: 0, width: 0 }}
                />
              </div>
              <div className="ps__rail-y" style={{ top: 0, right: 0 }}>
                <div
                  className="ps__thumb-y"
                  tabIndex={0}
                  style={{ top: 0, height: 0 }}
                />
              </div>
            </nav>
            <button
              onClick={() => setDisplaySidebar(!displaySidebar)}
              className="sidebar-minimizer brand-minimizer"
              type="button"
            />
          </div>
          <main className="main">{children}</main>
        </div>

        <div
          className="modal fade"
          id="modalMarketRules"
          tabIndex={-1}
          role="dialog"
          aria-labelledby="modalMarketRules"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Market Rules
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div id="market-rules-text" className="modal-body"></div>
            </div>
          </div>
        </div>
        <footer
          style={{
            display: "",
            position: "unset",
            height: "50px",
            borderTop: "1px solid #c8ced3",
            background: "#e8eaec"
          }}
        >
          <div className="marquee">
            <div className="marquee-track">
              <span
                style={{
                  paddingLeft: "5px",
                  font: "bold 12px Verdana",
                  colo: "#000000"
                }}
              >
                Welcome to Exchange.
              </span>
            </div>
          </div>
        </footer>

        <style>{`
 

.marquee:hover .marquee-content {
  animation-play-state: paused;
}

.marquee {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  color:black;
}

.marquee-track {
  display: inline-flex;
  animation: scroll 8s linear infinite;
   width:50%;
}

.marquee-track span {
  flex-shrink: 0;
}

@keyframes scroll {
  from {
    transform: translateX(0);
  }

  to {
    transform: translateX(-50%);
  }
}

`}</style>
      </div>
    </>
  );
};

export default AgentLayout;
